// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2v8Oy","dragIcon":"SortableItem_dragIcon__tGcon","disabled":"SortableItem_disabled__18LNH"};